import axios from '../config/axios';

const API_BASE = '/location-hubs';

export const locationHubService = {
  // Get all hubs
  getAllHubs: (page = 1, perPage = 20, filters = {}) => {
    const params = {
      page,
      per_page: perPage,
      ...filters
    };
    return axios.get(API_BASE, { params });
  },

  // Get hubs without pagination (for dropdowns)
  getHubsForSelect: (filters = {}) => {
    return axios.get(API_BASE, {
      params: {
        all: 'true',
        ...filters,
      },
    });
  },

  // Get single hub
  getHub: (hubId) => {
    return axios.get(`${API_BASE}/${hubId}`);
  },

  // Create hub
  createHub: (data, companyId = null) => {
    const payload = { ...data };
    if (companyId) {
      payload.company_id = companyId;
    }
    return axios.post(API_BASE, payload);
  },

  // Update hub
  updateHub: (hubId, data) => {
    return axios.put(`${API_BASE}/${hubId}`, data);
  },

  // Delete hub
  deleteHub: (hubId) => {
    return axios.delete(`${API_BASE}/${hubId}`);
  },

  downloadAttendanceQr: (hubId) => {
    return axios.get(`${API_BASE}/${hubId}/attendance-qr`, {
      responseType: 'blob',
    });
  },

  downloadBulkTemplate: () => {
    return axios.get(`${API_BASE}/bulk-template`, { responseType: 'blob' });
  },

  downloadBulkExport: (companyId = null) => {
    const params = {};
    if (companyId) params.company_id = companyId;
    return axios.get(`${API_BASE}/bulk-export`, { params, responseType: 'blob' });
  },

  uploadBulkExcel: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${API_BASE}/bulk-import`, formData, {
      headers: { 'Content-Type': undefined },
    });
  },
};